export const sitecoreAILogo =
	'https://delivery-sitecore.sitecorecontenthub.cloud/api/public/content/logo-sitecoreai_deploy';
export const cactusLogo =
	'https://delivery-sitecore.sitecorecontenthub.cloud/api/public/content/spot-cactus-neutral';
export const checkmarkLogo =
	'https://delivery-sitecore.sitecorecontenthub.cloud/api/public/content/spot-check-circle-neutral';
